export * from "./reset"
export * from "./mixin"

export const MAX_TYPE_WIDTH = {
  // maxWidth: "30rem", // ch support fallback
  maxWidth: "36ch",
}
export const MAX_VIEW_WIDTH = {
  // maxWidth: "80rem", // ch support fallback
  maxWidth: "72ch",
}

export const GLOBAL_SHADOW = "2px 2px 2rem rgba(0, 0, 0, 0.33)"
export const TOUCH_TARGET = "2.5rem"

export const touchBoundary = `calc(${TOUCH_TARGET} / 2)`

export const colors = {
  DARK_GRAY: "#323232",
  MID_GRAY: "#7f7f7f",
  LIGHT_GRAY: "#cccccc",
  BLUE: "#0085ca",
  BLUE_20: "#CCE7F4",
  BLUE_50: "#80C2E5",
  VALID: "#008031",
  ERROR: "#FF5E00",
  PAPER_WHITE: "hsl(0, 0%, 99%, 1)",
  BACKGROUND_WHITE: "hsl(0, 0%, 97%, 1)",
}

export const measure = {
  THIN_BORDER: "0.1667rem",
  THICK_BORDER: "0.33rem",
}

export const typography = {
  MUSEO: "museo-slab, Rockwell, serif",
  UNIVIA: 'univia-pro, Helvetica, "Helvetica Neue", Arial, sans-serif',
}

export const Blue100Type = {
  color: colors.BLUE,
  fontWeight: 100,
}

export const White100Type = {
  color: colors.PAPER_WHITE,
  fontWeight: 100,
}

export const Gray700Type = {
  color: colors.DARK_GRAY,
  fontWeight: 700,
}

export const withTrimMarkMotif = {
  position: "relative",

  "&::before, &::after": {
    content: '""',
    display: "block",
    position: "absolute",
    width: "1rem",

    top: "100%",
    left: "100%",
    borderTop: `solid ${colors.PAPER_WHITE} 0.1rem`,
  },
  "&::before": {
    left: "calc(100% + 0.1rem)",
  },
  "&::after": {
    top: "calc(100% + 0.1rem)",
    transformOrigin: "left center",
    transform: "rotate(90deg)",
  },
}

export const IDENTITY = {
  "*": {
    fontFamily: typography.UNIVIA,
    color: colors.DARK_GRAY,

    transistionProperty: "color, background-color, font-size",
    transitionDuration: "0.3s",
    transitionTimingFunction: "ease-in-out",
  },
  "h1, h2, h3, h4, h5, a": {
    color: "inherit",
    fontFamily: typography.MUSEO,
    lineHeight: 1.2,
  },
  h1: {
    fontSize: "2rem",
  },
  h2: {
    fontSize: "1.6667rem",
  },
  h3: {
    fontSize: "1.3333rem",
  },

  a: {
    display: "inline-block",
    color: "inherit",
    cursor: "pointer",
    textDecoration: "none",
  },
  "p, br": {
    fontSize: "1rem",
    fontFamily: "inherit",
    lineHeight: 1.4,
  },

  address: {
    color: "inherit",
  },
}
